/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Trigger_Lesson_CreatedInputs */

const en_templates_trigger_lesson_created = /** @type {(inputs: Templates_Trigger_Lesson_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On lesson created`)
};

const he_templates_trigger_lesson_created = /** @type {(inputs: Templates_Trigger_Lesson_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביצירת שיעור`)
};

/**
* | output |
* | --- |
* | "On lesson created" |
*
* @param {Templates_Trigger_Lesson_CreatedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_trigger_lesson_created = /** @type {((inputs?: Templates_Trigger_Lesson_CreatedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Trigger_Lesson_CreatedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_trigger_lesson_created(inputs)
	return he_templates_trigger_lesson_created(inputs)
});